import styled from "@emotion/styled";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer, Grid, IconButton } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import Nav from "./Navigation";

const HeaderGrid = styled(Grid)`
  max-width: 1500px;
  @media (max-width: 1548px) {
    max-width: calc(100% - 100px);
  }
  @media (max-width: 900px) {
    max-width: 100%;
  }
  margin: 0 auto;
`;

const HeadingLink = styled(Link)` 
  text-decoration: none;
  display: block;
  margin: 30pt 10pt 30pt 10pt;
`

const Logo = styled.img`
  width: 150pt;
  @media (max-width: 899px) {
    width: 120pt;
  }
`
const StyledMenuIcon = styled(MenuIcon)`
  color: #000;
  font-size: 24pt;
  padding: 10px;
`

const StyledIconButton = styled(IconButton)`
  margin: 10pt;
`

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header>
      <HeaderGrid container direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}>
        <Grid item xs={3} md={3} sx={{ display: { xs: "block", md: "none" } }}>
          <StyledIconButton onClick={() => setMenuOpen(true)}>
            <StyledMenuIcon color={'primary'} />
          </StyledIconButton>
        </Grid>
        <Grid item xs={6} md={3} sx={{ textAlign: { xs: "center", md: "left" } }}>
          <HeadingLink to={"/"}>
            <Logo
              src={"/logo.png"}
              alt={"Bhagya Perera Art"}
            />
          </HeadingLink>
        </Grid>
        <Grid item xs={6} md={6} sx={{ display: { xs: "none", md: "block" } }}>
          <Nav onMenuSelection={() => setMenuOpen(false)} />
        </Grid>
        <Grid item xs={3} md={3}>
        </Grid>

        <Drawer
          anchor={'top'}
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
        >
          <Grid container direction={'column'}>
            <Grid item xs={12}>
              <Nav onMenuSelection={() => setMenuOpen(false)} />
            </Grid>
            <Grid item xs={12} textAlign={'center'}>
              <IconButton onClick={() => setMenuOpen(false)} style={{ marginBottom: 25 }}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Drawer>

        {/* <Grid xs={12} sx={{
          textAlign: 'center',
          fontSize: 24,
          backgroundColor: '#ba494e',
          borderRadius: 5,
          marginBottom: 5,
          marginRight: 5,
          marginLeft: 5,
          lineHeight: 1.5
        }}>
          <a href="https://google.com" style={{
            display: 'block',
            color: '#fff',
            textDecoration: 'none',
            width: '100%',
            padding: 16,
          }}>
            Charity sale! 60% off selected items, all sale proceeds goes to local food bank to support them during this holiday season.
          </a>
        </Grid> */}
      </HeaderGrid>
    </header>
  );
};

export default Header;
